import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { User } from '@mkp/user/models';

export const readLoggedInUserSuccess = createAction(
  `[User Api] Read Logged In User Success`,
  props<{ user: User }>()
);
export const readLoggedInUserFailure = createAction(
  `[User Api] Read Logged In User Failure`,
  props<{ error: { message: string } }>()
);

export const updateUserSuccess = createAction(
  `[User Api] Update User Success`,
  props<Update<User>>()
);
export const updateUserFailure = createAction(
  `[User Api] Update User Failure`,
  props<{ error: { message: string } }>()
);

export const updateUserNoChanges = createAction(`[User Api] Update User No Changes`);

export const createUserOnAccountSuccess = createAction(
  `[User Api] Create User On Account Success`,
  props<{ user: User; successMessage: string }>()
);
export const createUserOnAccountFailure = createAction(
  `[User Api] Create User On Account Failure`,
  props<{ error: { message: string } }>()
);

export const listUsersSuccess = createAction(
  `[User Api] List Users Success`,
  props<{ users: User[]; _links: any; filter: any; totalCount: any }>()
);
export const listUsersFailure = createAction(
  `[User Api] List Users Failure`,
  props<{ error: { message: string } }>()
);

export const loadMoreUsersSuccess = createAction(
  `[User Api] Load More Users Success`,
  props<{ users: User[]; _links: any; filter: any; totalCount: any }>()
);
export const loadMoreUsersFailure = createAction(
  `[User Api] Load More Users Failure`,
  props<{ error: { message: string } }>()
);

export const resetPasswordSuccess = createAction(`[User Api] Reset Password Success`);
export const resetPasswordFailure = createAction(
  `[User Api] Reset Password Failure`,
  props<{ error: { message: string } }>()
);

export const resetMfaSuccess = createAction(`[User Api] Reset Mfa Success`);
export const resetMfaFailure = createAction(
  `[User Api] Reset Mfa Failure`,
  props<{ error: { message: string } }>()
);

export const loadUsersByIdsSuccess = createAction(
  `[User Api] Load Users By Ids Success`,
  props<{ users: User[] }>()
);
export const loadUsersByIdsFailure = createAction(
  `[User Api] Load Users By Ids Failure`,
  props<{ error: { message: string } }>()
);

export const updateIncompleteUserSuccess = createAction(
  `[User Api] Update Incomplete User Success`,
  props<{ user: User }>()
);
export const updateIncompleteUserFailure = createAction(
  `[User Api] Update Incomplete User Failure`,
  props<{ error: { message: string } }>()
);

export const createPasswordlessUserSuccess = createAction(
  `[User Api] Create User On Redeem Invite Success`,
  props<{ token: string; email: string }>()
);

export const createPasswordlessUserFailure = createAction(
  `[User Api] Create User On Redeem Invite Failure`,
  props<{ error: unknown }>()
);
